import request from "../axios";

// 七牛云Token
export function getQiniuToken(params) {
  return request({
    url: "/communal/qiniu-token",
    method: "get",
    params,
  });
}

// 获取七牛云私有空间图片地址
export function getQiniuUpload(params) {
  return request({
    url: "/communal/qiniu-detail",
    method: "get",
    params,
  });
}

// 获取阿里云临时授权
export function aliyunSample(params) {
  return request({
    url: "/communal/aliyun-sample",
    method: "get",
    params,
  });
}

// 获取菜单类型数据
export function getMenuType(params) {
  return request({
    url: "/communal/menutype",
    method: "get",
    params,
  });
}

// 获取省
export function getProvince(params) {
  return request({
    url: "/communal/province",
    method: "get",
    params,
  });
}

// 获取市
export function getCity(params) {
  return request({
    url: "/communal/city",
    method: "get",
    params,
  });
}

// 获取区
export function getArea(params) {
  return request({
    url: "/communal/area",
    method: "get",
    params,
  });
}

// 获取教育集团
export function getGroup(params) {
  return request({
    url: "/communal/group",
    method: "get",
    params,
  });
}

// 获取学校
export function getSchool(params) {
  return request({
    url: "/communal/school",
    method: "get",
    params,
  });
}

// 获取年级
export function getGrade(params) {
  return request({
    url: "/communal/grade",
    method: "get",
    params,
  });
}

// 获取班级
export function getClass(params) {
  return request({
    url: "/communal/class",
    method: "get",
    params,
  });
}

// 获取教师
export function getTeacher(params) {
  return request({
    url: "/communal/teacher",
    method: "get",
    params,
  });
}

// 获取学生
export function getStudent(params) {
  return request({
    url: "/communal/student",
    method: "get",
    params,
  });
}

// 获取学校学段
export function getPeriod(params) {
  return request({
    url: "/communal/period",
    method: "get",
    params,
  });
}

// 获取学科
export function getSubject(params) {
  return request({
    url: "/communal/subject",
    method: "get",
    params,
  });
}

// 获取班主任类型
export function getTeacherType(params) {
  return request({
    url: "/communal/teacher-class-type",
    method: "get",
    params,
  });
}

// 获取试卷类型
export function getExamPaperType(params) {
  return request({
    url: "/communal/exam-paper-type",
    method: "get",
    params,
  });
}

// 获取试题类型
export function getExamQuestionType(params) {
  return request({
    url: "/communal/exam-question-type",
    method: "get",
    params,
  });
}
